import { planningAPI } from "../../axios";

export const actions = {
    // ModeOfVerification
    GetMOVByTarget(context, data){
        return planningAPI.get(`ModeOfVerification/Target/${data}`);
    },
    GetSingleMOV(context, data){
        return planningAPI.get(`ModeOfVerification/${data}`);
    },
    CreateMOV(context, data){
        return planningAPI.post(`ModeOfVerification/Create`, data);
    },
    UpdateMOV(context, data){
        return planningAPI.put(`ModeOfVerification/Update/${data.id}`, data);
    },
    DeleteMOV(context, data){
        return planningAPI.delete(`ModeOfVerification/Remove/${data}`);
    },
}
